export enum ConfigurationTabItem {
    Overview = 'Overview',
    Rules = 'Rules',
    Design = 'Design',
}
